import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { Collections } from "../utils/collections";
import { functions } from "../firebase/firebase";
import { httpsCallable } from "firebase/functions";
import { AssignPassRM, AssignPassesRequestRM, UserPassRM } from "@/models/request-models";
import { AppleWallet } from "@/models/wallet";
const path = require('path');


export async function SubmitDiversityPassApplicationForm(
  obj: any
): Promise<boolean> {
  try {
    await addDoc(collection(db, Collections.FREE_PASS_APPLICATION), obj);
    return true;
  } catch (ex) {
    return false;
  }
}

export async function sendLoginUrl(email: string, redirectUrl: string) {
  const generateLoginLink = httpsCallable(functions, "generateLoginLink");
  return await generateLoginLink({ email: email, continueUrl: redirectUrl })
    .then((_) => true)
    .catch((_) => false);
}

export async function callAssignPassesRequest(payload: AssignPassesRequestRM): Promise<{ success: boolean; error?: string }> {
  const onAssignPasses = httpsCallable(functions, "onAssignPassesRequest");
  try {
    await onAssignPasses(payload);
    return { success: true };
  } catch (error: any) {
    console.error("Assign passes error:", error);
    return {
      success: false,
      error: error?.message || "Failed to assign passes. Please try again."
    };
  }
}

export async function callAssignPass(payload: AssignPassRM) {
  const onAssignPasses = httpsCallable<
    AssignPassRM,
    { success: boolean; error: string }
  >(functions, "onAssignPass");
  try {
    const result = await onAssignPasses(payload);
    return result.data;
  } catch (e) {
    return { success: false, error: "" };
  }
}

export async function callGeneratePass(payload: UserPassRM) { 
  const generatePass = httpsCallable(functions, "generatePass");
    const result  = await generatePass(payload);
    return result.data;
}
